import Axios from "axios";
import React, { Component } from "react";
import * as Cookie from "js-cookie";
import Form from "../Form/Form";
import templates from "../FormTemplates";
import connection from "../../api/config/connection";
import Submit from "../FormTemplates/Form/Submit";

const levels = {
  visitor: 200,
  none: -1000,
  essential: 0,
};

export class CookieSelector extends Component {
  constructor() {
    super();
    this.alert = document.getElementsByClassName("js-cookie-consent-alert")[0];
    this.state = { advanced: false, isSubmitting: false, disabled: false };
  }
  render() {
    const { form, submitButton, action, adjustText, refuseText } = this.props;
    const { advanced, isSubmitting, disabled } = this.state;

    return advanced ? (
      <Form
        className="cookie-consent-alert__panel"
        config={form}
        templates={templates}
        axios={connection.instance()}
        onSubmitted={(response) => {
          if (response.data.message === "ok") {
            this.setLevel(response.data.level);
            this.hideAlert();
          }
        }}
      />
    ) : (
      <div class="cookie-consent-alert__actions">
        <Submit
          config={submitButton}
          isSubmitting={isSubmitting}
          disabled={disabled}
          handleClick={(e) => {
            this.setState({ isSubmitting: true });
            this.sendLevel(levels.visitor, action, (err) => {
              this.setState({ isSubmitting: false });
            });
          }}
        />
        <div class="cookie-consent-alert__action">
          <a
            className="link link--pointer"
            onClick={() =>
              isSubmitting || disabled || this.setState({ advanced: true })
            }
          >
            {adjustText}
          </a>
        </div>
        <div class="cookie-consent-alert__action">
          <a
            className="link link--pointer"
            onClick={(e) => {
              if (!isSubmitting && !disabled) {
                this.setState({ disabled: true });
                this.sendLevel(levels.none, action, (err) => {
                  this.setState({ disabled: false });
                });
              }
            }}
          >
            {refuseText}
          </a>
        </div>
      </div>
    );
  }

  sendLevel = (level, url, errorCallback) => {
    if (!url) {
      this.setLevel(level);
      return;
    }

    Axios.post(url, {
      level,
    })
      .catch(errorCallback)
      .then((data) => {
        this.setLevel(data.level || level);
        this.hideAlert();
      });
  };

  setLevel = (level) => {
    if (level < 0) Cookie.set("CMSCookieLevel", level, { expires: 31 });
    if (window.MsCrmMkt) {
      window.MsCrmMkt.reconfigureTracking({
        Anonymize: !(level >= levels.essential),
      });
    }
  };

  hideAlert = () => {
    this.alert.classList.add("is-hidden");
    setTimeout(() => {
      this.alert.remove();
    }, 250);
  };
}

export default CookieSelector;



// WEBPACK FOOTER //
// ./src/components/Cookies/CookieSelector.js